import last from "lodash/last";

import type { RequestStatus } from "~/tools/request-status";
import { mapObservableValue } from "~/tools/request-status/map-observable-value";
import type { Observable } from "~/tools/rxjs";

import {
	Api,
	type EventCursor,
	type EventElement,
	type EventRelation,
	type GetEventsError,
	type GetEventsParams,
	type GetEventsSuccess,
	getEventsObservable,
} from "../common/openapi";
import type { ParamsMeta } from "../generic/request";

export type ApiEventItemsWithTotalAndNextCursor = GetEventsSuccess & { nextCursor?: EventCursor | undefined };
export type GetEventsStatusWithNextCursor = RequestStatus<
	GetEventsError,
	ApiEventItemsWithTotalAndNextCursor,
	ParamsMeta<GetEventsParams>
>;
export function getEventsObservableWithNextCursor(params: GetEventsParams): Observable<GetEventsStatusWithNextCursor> {
	return getEventsObservable(params).pipe(
		mapObservableValue((value) => {
			const lastItem = last(value.items);
			const nextCursor: EventCursor | undefined =
				value.items.length > 0 && (params.body.limit == null || value.items.length === params.body.limit)
					? {
							lastEventId: lastItem!.identifier,
							lastEventTimestampMs: lastItem!.eventTime,
						}
					: undefined;
			return { ...value, nextCursor };
		}),
	);
}

// TODO STAC-20567: check usage and remove it from all places
export function isEventRelation(event: EventElement): event is EventRelation {
	return event._type === Api.EventRelation.TypeEnum.EventRelation;
}
